import { Injectable, signal } from '@angular/core';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';

@Injectable({ providedIn: 'root' })
export class PushService {
  private registration: ServiceWorkerRegistration | null = null;
  private subscription: PushSubscription | null = null;
  abone = signal(false);
  destekleniyor = signal(false);

  constructor() { this.init(); }

  private async init() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    this.destekleniyor.set(true);
    try {
      this.registration = (await navigator.serviceWorker.getRegistration('/')) ?? null;
      if (!this.registration) {
        this.registration = await navigator.serviceWorker.register('/push-sw.js', { scope: '/' });
      }
      this.subscription = await this.registration.pushManager.getSubscription();
      this.abone.set(!!this.subscription);
    } catch (e) {
      console.warn('[Push] SW register basarisiz:', e);
    }
  }

  async aboneOl(): Promise<boolean> {
    if (!this.registration) return false;
    try {
      const vapidKey = await this.vapidKeyAl();
      if (!vapidKey) return false;

      const sub = await this.registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: this.urlBase64ToUint8Array(vapidKey).buffer as ArrayBuffer,
      });
      this.subscription = sub;

      const json = sub.toJSON();
      const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.push.abonelik-kaydet' });
      istek.parametreler = {
        endpoint: json.endpoint,
        keys: { p256dh: json.keys?.['p256dh'], auth: json.keys?.['auth'] },
      };
      await istek.isteSync();

      this.abone.set(true);
      return true;
    } catch (e) {
      console.error('[Push] Abonelik hatası:', e);
      return false;
    }
  }

  async aboneDurumuKontrol(): Promise<void> {
    if (!this.destekleniyor()) return;
    try {
      const reg = await navigator.serviceWorker.ready;
      const sub = await reg.pushManager.getSubscription();
      this.subscription = sub;
      this.abone.set(!!sub);
    } catch {}
  }

  async abonelikIptal(): Promise<void> {
    if (!this.subscription) return;
    try {
      const endpoint = this.subscription.endpoint;
      await this.subscription.unsubscribe();

      const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.push.abonelik-sil' });
      istek.parametreler = { endpoint };
      await istek.isteSync();
    } catch {}
    this.subscription = null;
    this.abone.set(false);
  }

  private async vapidKeyAl(): Promise<string | null> {
    try {
      const istek = new FikoYTIstekKok({ metod: 'POST', komut: 'FikoYT.sistem.push.vapid-public-key' });
      await istek.isteSync();
      return (istek.cevap?.sonuc as any)?.vapidPublicKey || null;
    } catch { return null; }
  }

  private urlBase64ToUint8Array(base64String: string): Uint8Array {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
  }
}
